<div style="display: flex; justify-content: center; align-items: center;" class="h-full">

    <input
        #fileInput
        id="{{ formLabelPhoto }}"
        type="file"
        accept=".pdf"
        (change)="onFileSelected($event)"
        [disabled]="disabled"
        hidden
    >

    <div>

        <div style="display: flex; justify-content: space-between;">
            <div>
                <label class="label-pz">{{label}}</label>
            </div>
            <div>
              <i (click)="op.toggle($event)"
                 style="color: var(--color-primario); cursor: pointer; font-size: 20px;"
                 class='bx bxs-info-circle repeating-animation'></i>
            </div>
        </div>

        <div
            [ngStyle]="{'width': width, 'min-height': height}"
            [ngClass]="{
                'valid-document': form.get(formLabelPhoto)?.value && !disabled,
                'invalid-document': !form.get(formLabelPhoto)?.value && !disabled,
                'disabled-document': disabled
            }"
            class="image-preview flex justify-content-center align-items-center image-container "
            (click)="triggerFileInputClick()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            [class.dragging]="isDragging"
            style="cursor: pointer; border-radius: 12px; text-align: center;"
        >
            <i *ngIf="!disabled"
                [ngClass]="{
                'bxs-check-circle success-color': form.get(formLabelPhoto)?.value,
                'bxs-x-circle error-color': !form.get(formLabelPhoto)?.value
                }"
                class="icon-status-file bx">
            </i>
            <div *ngIf="form.get(formLabelPhoto)?.value" class="w-full h-full flex justify-content-center align-items-center flex-wrap document-selected">
                <div class="flex align-items-center justify-content-center w-full font-bold p-5">
                    <i style="font-size: 56px; color: red;" class='bx bxs-file-pdf'></i>
                </div>
                <div style="font-size: 12px;" class="flex align-items-center justify-content-center w-full font-bold	">
                    {{ fileName }}
                </div>
                <div style="font-size: 14px;" class="flex align-items-center justify-content-center w-full">
                    {{ fileSize }} KB
                </div>
            </div>

            <div
                class="w-full flex flex-column justify-content-center align-items-center"
                *ngIf="!form.get(formLabelPhoto)?.value"
                style="cursor: pointer; border-radius: 12px; text-align: center; padding: 10px;"
            >
                <div *ngIf="!disabled; else elseBlock">
                    <div><i style="font-size: 25px;" class='bx bx-upload'></i></div>
                    <div style="padding-bottom: 5px;"><span style="font-size: 12px;">Arrastrar y soltar el archivo para cargar <b style="font-size: 12px;">o dar click</b></span></div>
                    <p-button severity="info">
                        <span style="display: flex;" class="p-button-label">
                            <span style="font-size: 12px;">&nbsp;Cargar</span>
                        </span>
                    </p-button>
                    <div style="font-size: 12px; padding-top: 5px;">Máximo <span style="font-weight: bold;">1MB</span></div>
                </div>
                <ng-template #elseBlock>
                    <i style="font-size: 25px; color: rgb(173, 168, 168);" class='bx bxs-lock-alt'></i>
                    <p style="font-size: 12px; color: rgb(173, 168, 168);" >Desbloquear cargando el documento anterior</p>
                </ng-template>
            </div>

            <div *ngIf="!disabled" class="overlay">
                <div class="overlay-content">
                    <div pTooltip="quitar" *ngIf="form.get(formLabelPhoto)?.value" (click)="clearDocument($event)" style="position: absolute; right: 10px; top: 10px; border-color: #0354A9 !important;" class="flex justify-content-end flex-wrap">
                        <i style="font-size: 12px; padding: 3px; background: red; border-radius: 10px;" class='bx bx-x'></i>
                    </div>
                    <div><i style="font-size: 25px;" class='bx bx-upload'></i></div>
                    <div style="padding-bottom: 5px;"><span style="font-size: 12px;">Arrastrar y soltar el archivo para cargar <b style="font-size: 12px;">o dar click</b></span></div>
                    <p-button severity="info">
                        <span style="display: flex;" class="p-button-label">
                            <span style="font-size: 12px;">&nbsp;Cargar</span>
                        </span>
                    </p-button>
                    <div style="font-size: 12px; padding-top: 5px">Máximo <span style="font-weight: bold;">1MB</span></div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-popover #op [style]="{'width': '300px'}" >
    <p style="font-size: 12px;"> {{messageInfo}} </p>
</p-popover>
